import constants from '@/app-configs/constants'
import economicLogo from '@/assets/images/logo/economic.png'
import dineroLogo from '@/assets/images/logo/dinero.png'
import axios from '@axios'

let status = {}
async function getIntegrationStatus() {
  const url = '/integrations/status'
  await axios.get(url).then(response => {
    status = response.data.data
  })
}

export default async () => {
  await getIntegrationStatus()
  const menu = []

  if (status.economic_integration_status === true) {
    menu.push({
      title: 'E-conomic',
      route: 'E-conomic',
      icon: economicLogo,
      action: constants.action.permissionLogin,
      resource: constants.resource.user,
    })
  }

  if (status.dinero_integration_status === true) {
    menu.push({
      title: 'Dinero',
      route: 'Dinero',
      icon: dineroLogo,
      action: constants.action.permissionLogin,
      resource: constants.resource.user,
    })
  }

  const subItems = []

  if (!status.economic_integration_status) {
    subItems.push({
      title: 'E-conomic',
      route: 'E-conomic',
      icon: economicLogo,
      action: constants.action.permissionLogin,
      resource: constants.resource.user,
    })
  }

  if (!status.dinero_integration_status) {
    subItems.push({
      title: 'Dinero',
      route: 'Dinero',
      icon: dineroLogo,
      action: constants.action.permissionLogin,
      resource: constants.resource.user,
    })
  }

  if (subItems.length > 0) {
    menu.push({
      title: 'DEBTIA_INTEGRATIONS',
      icon: 'GridIcon',
      children: subItems,
    })
  }
  return menu
}
